import React from 'react';

export default function SVGShieldCheck(): JSX.Element {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className="text-iconStrong stroke-current fill-current"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="SVG_SHIELD"
    >
      <path d="M10.746.002a.8.8 0 00-.309.075l-9.335 4.5a.8.8 0 00-.45.717v3.61c0 6.715 4.02 12.473 9.81 15.027a.8.8 0 00.65 0c5.791-2.554 9.81-8.312 9.81-15.028V5.294a.8.8 0 00-.45-.717l-9.334-4.5a.8.8 0 00-.392-.075zm.042 1.683l8.535 4.118v3.1c0 5.947-3.488 11.017-8.535 13.394C5.74 19.92 2.253 14.85 2.253 8.903v-3.1l8.535-4.118zm4.725 6.31a.8.8 0 00-.475.225l-5.576 5.326-2.375-2.376a.8.8 0 10-1.134 1.126l2.934 2.933a.8.8 0 001.117.017l6.135-5.868a.8.8 0 00-.626-1.383z" />
    </svg>
  );
}

SVGShieldCheck.defaultProps = {
  color: '#33B236',
};
